export enum OnboardingStageCode{
    Unknown = -1,
    PaidTicketing = 0,
    FirstOrganizationBasicInfo = 1,
    FirstOrganizationBankInfo = 2,
    ActivateOrganization = 3,
    SetupSuccessful = 4,
    SetupFailed = 5,
}